import api from './client';

export interface RoadmapProject {
  id: number;
  name: string;
  description: string | null;
}

export interface RoadmapItem {
  id: number;
  project_id: number;
  title: string;
  description: string | null;
  priority: 'high' | 'medium' | 'low';
  status: 'plan' | 'progress' | 'done';
  category: 'frontend' | 'backend' | 'infra' | 'other' | null;
  sort_order: number;
}

export type ItemCreate = Omit<RoadmapItem, 'id' | 'project_id'>;
export type ItemUpdate = Partial<ItemCreate>;

// Projects
export const getProjects = () =>
  api.get<RoadmapProject[]>('/roadmap/projects').then(r => r.data);

export const createProject = (data: { name: string; description?: string }) =>
  api.post<RoadmapProject>('/roadmap/projects', data).then(r => r.data);

export const updateProject = (id: number, data: { name?: string; description?: string }) =>
  api.put<RoadmapProject>(`/roadmap/projects/${id}`, data).then(r => r.data);

export const deleteProject = (id: number) =>
  api.delete(`/roadmap/projects/${id}`);

// Items
export const getItems = (projectId: number) =>
  api.get<RoadmapItem[]>(`/roadmap/projects/${projectId}/items`).then(r => r.data);

export const createItem = (projectId: number, data: ItemCreate) =>
  api.post<RoadmapItem>(`/roadmap/projects/${projectId}/items`, data).then(r => r.data);

export const updateItem = (id: number, data: ItemUpdate) =>
  api.put<RoadmapItem>(`/roadmap/items/${id}`, data).then(r => r.data);

export const deleteItem = (id: number) =>
  api.delete(`/roadmap/items/${id}`);
